const getSprintsItems = state => state.sprints.items;

const sprintsSelectors = {
  getSprintsItems,
};

export default sprintsSelectors;
